var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossRedCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF0000",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "X-white",
    transform: "translate(5.000000, 5.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,-1.25 C5.38353108,-1.25 5.69444444,-0.939086632 5.69444444,-0.555555556 L5.69444444,10.5555556 C5.69444444,10.9390866 5.38353108,11.25 5,11.25 C4.61646892,11.25 4.30555556,10.9390866 4.30555556,10.5555556 L4.30555556,-0.555555556 C4.30555556,-0.939086632 4.61646892,-1.25 5,-1.25 Z",
    id: "Rectangle",
    transform: "translate(5.000000, 5.000000) rotate(45.000000) translate(-5.000000, -5.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,-1.25 C5.38353108,-1.25 5.69444444,-0.939086632 5.69444444,-0.555555556 L5.69444444,10.5555556 C5.69444444,10.9390866 5.38353108,11.25 5,11.25 C4.61646892,11.25 4.30555556,10.9390866 4.30555556,10.5555556 L4.30555556,-0.555555556 C4.30555556,-0.939086632 4.61646892,-1.25 5,-1.25 Z",
    id: "Rectangle-Copy",
    transform: "translate(5.000000, 5.000000) rotate(-45.000000) translate(-5.000000, -5.000000)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossRedCircle);
export default __webpack_public_path__ + "static/media/cross-red-circle.a814781b5d2a7440fe0e8483beace468.svg";
export { ForwardRef as ReactComponent };